import {
  createHevitonApiWebLegacy,
  type HevitonApiWebLegacy,
} from '@heviton/heviton-api-web-legacy';
import { useAuthStore } from '@/entities/auth';
import { env } from '@/env';
import type { ApiCallbacks } from './api-callbacks';

/**
 * `HevitonApiWebLegacy` factory — v3 옆에 병행 배선되는 레거시 데이터 도메인(/api/2.0) 클라이언트.
 * v2 와 동일 BE(heviton-api) — 같은 origin·access token·횡단 콜백 공유, prefix 만 다름(`/api/2.0`).
 *
 * 401 재발급은 composition 의 공통 `reissue`(single-flight, refresh HTTP 는 v3 클라이언트) 를 주입받아
 * 호출한다 — 세 API 가 같은 함수를 공유(동시 401 시 refresh rotation 중복 없음). v2 배선과 동형.
 */
export function createApiWebLegacy(
  callbacks: ApiCallbacks,
  refreshToken: () => Promise<string | null>,
): HevitonApiWebLegacy {
  return createHevitonApiWebLegacy({
    baseURL: env.api.webLegacy.baseUrl,
    getAccessToken: () => useAuthStore.getState().accessToken,
    refreshToken,
    ...callbacks,
  });
}
